<template>
  <div>
    <ClaimList :claims="claims" @pause="(claim) => this.$emit('pause', claim)" />
    <Pagination
      :currentPage="currentPage"
      :totalPages="totalPages"
      :totalCount="totalCount"
      @changePage="handleChangePage"
    />
  </div>
</template>

<script>
import ClaimList from "@/components/claim/list/ClaimList.vue";
import { Pagination } from "@estaly/ui";

export default {
  components: {
    Pagination,
    ClaimList,
  },
  props: {
    claims: {
      type: Array,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: false,
    },
    totalCount: {
      type: Number,
      required: false,
    },
  },
  methods: {
    handleChangePage(page) {
      this.$emit("changePage", page);
    },
  },
};
</script>
